import { Alert } from "@material-ui/lab";
import React from "react";
import { NavLink, useHistory } from "react-router-dom";
import { TRANSFER_STATUSES } from "../../../../../utils/consts";
import { fetchFilterData } from "../../../../../utils/fetchFilterData";
import { StyledCashFlowProfitDetailsWrapper } from "../../../../cashFlow/admin/profit/styledCashFlowProfit";
import PageSpinner from "../../../../elements/spinner/PageSpinner";
import { StyledBreakWord } from "../../../../styles/styledBreakWord";
import {
  StyledCol,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../../../styles/styledTable";

const ExchangeProfitItemDetailsList = ({ profitDetails, filterData, t }) => {
  const history = useHistory();

  if (!profitDetails) {
    return (
      <PageSpinner
        position="center"
        pt="20"
        pb="20"
      />
    );
  }

  const showExchanges = (e, value) => {
    let filterUrl = fetchFilterData({
      page: 1,
      itemsPerPage: 30,
      currentTab: "exchange-history",
      ["pair.user.email"]: value.email,
      ["pair.exchangePair.inService.name"]: value.service,
      ["pair.exchangePair.inCurrency.asset"]: value.currency,
      ["status.value"]: TRANSFER_STATUSES.PROCESSED,
      ["createdAt[gte]"]: filterData.dateFrom,
      ["createdAt[lte]"]: filterData.dateTo
    });

    history.push(`/exchange${filterUrl}`);
  };

  if (profitDetails.length === 0) {
    return <Alert severity="warning">{t("profit.table.emptyData")}</Alert>;
  }

  return (
    <StyledCashFlowProfitDetailsWrapper>
      <StyledTable
        size="16"
        className="service-profit-table"
      >
        <StyledTableHead col="2" className="service-profit-table__head">
          <div>
            {t("profit.table.user")}
          </div>
          <div>
            {t("profit.table.profit")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {profitDetails && profitDetails.map((value, key) => (
            <StyledTableRow
              onClick={(e) => showExchanges(e, value)}
              col="2"
              key={key}
              cursor="pointer"
              className="service-profit-table__row"
            >
              <StyledCol data-title={t("profit.table.user")} inline>
                <StyledBreakWord>
                  {value.email}
                </StyledBreakWord>
              </StyledCol>
              <StyledCol data-title={t("profit.table.profit")}>
                {value.profit ?? 0} {value.currency}
              </StyledCol>
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledCashFlowProfitDetailsWrapper>
  );
};

export default ExchangeProfitItemDetailsList;